export default "__VITE_ASSET__z_OzPECA__"